
 

 

 

 
class ConfigurationRequest 
{
    
        ConfigurationItemCode: string;
    
        ConfigurationItemValue: string;
    
        ConfigurationItemName: string;
    
}
 
export default ConfigurationRequest;
 




